import { Link } from 'react-router-dom';
import { Clock, ChevronRight } from 'lucide-react';
import type { HelpArticle } from '../../types/help';

interface HelpArticleCardProps {
  article: HelpArticle;
}

export default function HelpArticleCard({ article }: HelpArticleCardProps) {
  return (
    <Link
      to={`/help/${article.category}/${article.slug}`}
      className="group flex items-center justify-between gap-4 rounded-lg border p-4 transition-all hover:border-[var(--oro-gold)]"
      style={{
        backgroundColor: 'var(--oro-surface)',
        borderColor: 'var(--oro-border)',
      }}
    >
      <div className="min-w-0 flex-1">
        <h3
          className="font-medium group-hover:text-[var(--oro-gold)] transition-colors"
          style={{ color: 'var(--text-primary)' }}
        >
          {article.title}
        </h3>
        <p
          className="mt-1 text-sm line-clamp-2"
          style={{ color: 'var(--text-secondary)' }}
        >
          {article.description}
        </p>
        <div
          className="mt-2 flex items-center gap-1.5 text-xs"
          style={{ color: 'var(--text-muted)' }}
        >
          <Clock className="h-3.5 w-3.5" />
          <span>{article.duration}</span>
          <span className="mx-1">•</span>
          <span>{article.steps.length} steps</span>
        </div>
      </div>
      <ChevronRight
        className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1"
        style={{ color: 'var(--text-muted)' }}
      />
    </Link>
  );
}
